import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import HeaderW from "../../components/HeaderW/HeaderW";

import testImage from "../../assets/images/backgrounds/Startsidabeskärd.png";

import headerImage from "../../assets/images/backgrounds/Startsida.jpg";
import Do from "./components/Do/Do";
import Filler from "./components/Filler/Filler";
//import Projects from "./components/Projects/Projects";
import Opinion from "./components/Opinion/Opinion";

import "./StartPage.css";

class StartPage extends PureComponent {
  render() {
    return (
      <div className="start-page">
        <Helmet>
          <title>Corviva</title>
          <meta name="description" content="Digital plattform för enkäter, undersökningar och möten som riktar sig till företag och organisationer som arbetar inom hälsa och arbetsmiljö." />
          <meta name="keywords" content="webbportal hälsa företagshälsovård arbetsmiljö hälsoundersökning" />
        </Helmet>
        {window.innerWidth >= 768 ? <HeaderW
          big_header="Nya förutsättningar"
          small_header="Vi hjälper er i digitaliseringen"
          bgImage={headerImage}
          page="startPage"
          offset={-40}
          strength={200}
        /> : 
        <HeaderW
          big_header="Corviva"
          small_header="Upptäck framtiden"
          bgImage={testImage}
          page="startPage"
          offset={-40}
          strength={200}
        /> 
        }
        <Do />
      {//  <Projects click_function={this.props.click_function} />
      }
        <Filler />
        <Opinion />
      </div>
    );
  }
}
StartPage.propTypes = {
  click_function: PropTypes.func
};

StartPage.defaultProps = {
  click_function: () => {}
};

export default StartPage;



// WEBPACK FOOTER //
// ./src/routes/StartPage/StartPage.jsx